// src/lib/api/utilities/expenseCategories.js
import { supabase } from '../../supabase'
import { getValidatedCompanyId } from '../shared/helpers'
import { withErrorHandling, createSuccessResponse } from '../shared/errors'
import { logger } from '../../logger'

/**
 * Get expense categories
 * Migrated from supabaseApi.js lines 485-505
 */
const _getExpenseCategories = async (companyId = null) => {
  logger.utilities('getExpenseCategories called with companyId:', companyId)
  
  const resolvedCompanyId = companyId || await getValidatedCompanyId()
  if (!resolvedCompanyId) {
    console.warn('[utilities] No company ID found')
    return createSuccessResponse([])
  }

  const { data, error } = await supabase
    .from('expense_categories')
    .select('*')
    .eq('company_id', resolvedCompanyId)
    .order('name', { ascending: true })
    
  if (error) {
    console.error('[utilities] Error fetching expense categories:', error)
    throw error
  }

  logger.utilities('getExpenseCategories success, found', data?.length || 0, 'categories')
  return createSuccessResponse(data || [])
}

/**
 * Get recurring expenses
 * Migrated from supabaseApi.js lines 506-527
 */
const _getRecurringExpenses = async (companyId = null) => {
  logger.utilities('getRecurringExpenses called with companyId:', companyId)
  
  const resolvedCompanyId = companyId || await getValidatedCompanyId()
  if (!resolvedCompanyId) {
    console.warn('[utilities] No company ID found')
    return createSuccessResponse([])
  }

  const { data, error } = await supabase
    .from('recurring_expenses')
    .select('*')
    .eq('company_id', resolvedCompanyId)
    .order('created_at', { ascending: false })
    
  if (error) {
    console.error('[utilities] Error fetching recurring expenses:', error)
    throw error
  }

  logger.utilities('getRecurringExpenses success, found', data?.length || 0, 'recurring expenses')
  return createSuccessResponse(data || [])
}

// Export functions with error handling
export const getExpenseCategories = withErrorHandling(_getExpenseCategories, 'get expense categories', 'expense_categories')
export const getRecurringExpenses = withErrorHandling(_getRecurringExpenses, 'get recurring expenses', 'recurring_expenses')